import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MenuService } from '../../services/menu.service';

@Component({
	selector: 'app-profile-pic',
	templateUrl: './profile-pic.component.html',
	styleUrls: ['./profile-pic.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfilePicComponent {
	@Input() size = 'large';       // small, medium, large
	// @Input() image: string;
	constructor(public readonly menuService: MenuService) { }

	get image() {
		return !!this.menuService.userProfile ? this.menuService.userProfile.pictureUrl : undefined;
	}
}
